export const LOGO = require('./jgg_logo.png'); 
export const BUTTON_1 = require('./button_1.png'); 
export const BUTTON_2 = require('./button_2.png'); 
export const BUTTON_3 = require('./button_3.png'); 
export const BUTTON_4 = require('./button_4.png'); 
export const BUTTON_5 = require('./button_5.png'); 
export const DASH = require('./dash.png'); 
